import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'unitOfReservation',
  standalone: false,
})
export class UnitOfReservationPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.RESERVATION_UNIT_PERIOD:
        type = this.translate.instant('日付（期間）');
        break;
      case AppConst.RESERVATION_UNIT_TIME:
      default:
        type = this.translate.instant('時間枠');
        break;
    }
    return type;
  }

}
